import React, { useState } from 'react';
import { formatPrice } from "../../util/formatPrice";
import { gaPackageBrowselinkedSection, gaPackageBrowseShopOrCustomizeClick } from '../../util/googleAnalytics';
import { LinkedProducts } from "../col-grad-annc/linkedProductModal";
import { CARD_LABELS } from './constants';
import { getUniquePackagesByDisplayName } from './utils';

const GradPackageTable = ({ 
	packageList, 
	productList, 
	fromGradPackages,
	altImage,
	pageContentData,
	googleAnalytics
}) => {
	const [showCustomize, setShowCustomize] = useState(false);
	const [selectedProduct, setSelectedProduct] = useState();

	const leftArrowClick = () => {
		let packageContainerElement = document.getElementById('grad_package-container');
		let currentScrollPosition = packageContainerElement.scrollLeft;
		let scrollToPosiotion = currentScrollPosition - Math.trunc(window.innerWidth / 2.5 - 20);
		packageContainerElement.scroll(scrollToPosiotion, 0);
	};

	const rightArrowClick = () => {
		let packageContainerElement = document.getElementById('grad_package-container');
		let currentScrollPosition = packageContainerElement.scrollLeft;
		let scrollToPosiotion = currentScrollPosition + Math.trunc(window.innerWidth / 2.5 - 20);
		packageContainerElement.scroll(scrollToPosiotion, 0);
	};

	const logGASelectItemEvent = async (product, ctaName) => {
		try {
			googleAnalytics?.selectItemTrackingGASY25(
				googleAnalytics?.catalogOSR,
				googleAnalytics?.customerClassCode,
				ctaName || 'Customize', 
				'',
				product?.displayName,
				'button_click',
				pageContentData?.title || 'GradPackage Table'
			);
			if (window?.jostensGaTracking?.gaEventsSpecPromise) {
				await Promise.all([window.jostensGaTracking.gaEventsSpecPromise])
			}
		} catch (err) {
			console.warn('GA tracking event failed', err)
		}
	}

	const onCustomizeClick = async (product, ctaName) => {
		await logGASelectItemEvent(product, ctaName);
		if (product?.linkedProducts?.length > 1 && !fromGradPackages) {
			gaPackageBrowselinkedSection(product)
			setShowCustomize(true)
			setSelectedProduct(product);
		} else if (product?.linkedProducts?.length === 1 && !fromGradPackages) {
			gaPackageBrowseShopOrCustomizeClick(product, ctaName)
			gaPackageBrowselinkedSection(product?.linkedProducts[0].publishedCatalogProductId)
			window.location.href = product?.linkedProducts[0].actionUrl;
		} else {
			!fromGradPackages && gaPackageBrowseShopOrCustomizeClick(product, ctaName)
			window.location.href = product.actionUrl;
		}
	}

	const scrollEle = () => {
		let packageContainerElement = document.getElementsByClassName(
			'grad_package-container'
		)[0];
		if (packageContainerElement.scrollLeft > 1) {
			document.getElementById('pkg-scroll-left').classList.add('active');
		} else {
			document.getElementById('pkg-scroll-left').classList.remove('active');
		}
		if (
			packageContainerElement.scrollLeft <
			packageContainerElement.scrollWidth -
			packageContainerElement.offsetWidth -
			10
		) {
			document.getElementById('pkg-scroll-right').classList.add('active');
		} else {
			document.getElementById('pkg-scroll-right').classList.remove('active');
		}
	};

	let counter = 1;
	const getDisplayValue = (text, index) => {
		if (text === '1') {
			return (
				<span className='grad_package-item-description' key={index}>
					<i className='fas fa-check'></i>
				</span>
			);
		} else if (text.length < 10) {
			return (
				<span className='grad_package-item-description' key={index}>
					{text}
				</span>
			);
		} else {
			return (
				<div className='grad_package-long-description' key={index}>
					<div className='long-description'>{text}</div>
					<div
						className='long-desc-popup d-none'
						id={'long-desc-popup-' + index}>
						<button
							className='close' title="Close"
							onClick={() => {
								document
									.getElementById('long-desc-popup-' + index)
									.classList.add('d-none');
							}}>
							<i className='fas fa-times'></i>
						</button>
						<div className='long-desc-popup-text'>{text}</div>
					</div>
					<span
						className='show-long-desc-popup'
						onClick={() => {
							document
								.getElementById('long-desc-popup-' + index)
								.classList.remove('d-none');
						}}>
						<i className='fas fa-info-circle'></i>
					</span>
				</div>
			);
		}
	};

	const uniquePackagesList = getUniquePackagesByDisplayName(packageList)

	return (
		<>
			<section className='grad-packages-comparison'>
				<div className='grad_packages' id='TRADITIONAL_PACKAGE'>
					<div
						className='grad_package items-list'
						style={{ width: `${100 / (productList?.length + 1)}%` }}>
						<div className='grad_package-wrapper'>
							<div className='grad_package-detail' style={fromGradPackages ? { minHeight: '276px' } : {}}></div>

							<div className='grad_package-info'>
								{uniquePackagesList?.length > 0 && uniquePackagesList.map((item, index) => {
									return (
										item.displayName !== "freeProducts" &&
										<li className='grad_package-item' key={index}>
											<span className='grad_package-item-description' title={item.displayName + "."}>
												{item.displayName}
											</span>
											<div className='long-desc-popup d-none' id={'item-name-popup-' + index}>
												<button className='close' title="Close"
													onClick={() => {
														document
															.getElementById('item-name-popup-' + index)
															.classList.add('d-none');
													}}>
													<i className='fas fa-times'></i>
												</button>
												<div className='long-desc-popup-text'>{item.displayName}</div>
											</div>
											{
												item.displayName.length && item.displayName.length >= 20 &&
												<span
													className='show-long-desc-popup d-sm-none'
													onClick={() => {
														document
															.getElementById('item-name-popup-' + index)
															.classList.remove('d-none');
													}}>
													<i className='fas fa-info-circle'></i>
												</span>
											}
										</li>
									);
								})}
							</div>
						</div>
					</div>

					<div
						className='pkg-scroll-btn pkg-scroll-left'
						onClick={() => leftArrowClick()}
						id='pkg-scroll-left'>
						<i className='fal fa-arrow-left'></i>
					</div>

					<div
						className='pkg-scroll-btn pkg-scroll-right active'
						onClick={() => rightArrowClick()}
						id='pkg-scroll-right'>
						<i className='fal fa-arrow-right'></i>
					</div>

					<div
						id='grad_package-container'
						className='grad_package-container'
						style={{
							gridTemplateColumns: `repeat(${productList?.length}, minmax(0, 1fr))`,
						}}
						onScroll={() => scrollEle()}>
						{productList?.length <= 5 &&
							productList.map((product, index) => {
								let parentClass = 'grad_package';
								let childClass = 'grad_package-wrapper';
								if (fromGradPackages) {
									if (product?.mostPopular) {
										parentClass = parentClass + ' mascot-pkg';
										childClass = childClass + ' best-package';
									} else {
										childClass = childClass + ' pkg-color-' + counter++;
									}
								} else {
									if (index === 0) {
										parentClass = parentClass + ' mascot-pkg';
										childClass = childClass + ' best-package';
									} else {
										childClass = childClass + ' pkg-color-' + counter++;
									}
								}
								counter = counter > 4 ? 1 : counter;

								const productPrice = product[fromGradPackages ? 'packagePrice' : 'retailPrice']
								const savePrice = formatPrice(product?.packageDiscountAmount, product?.currencyCode);
								const price = formatPrice(productPrice, product?.currencyCode)

								return (
									<div className={parentClass} key={index}>
										<div className={childClass}>
											<div className='grad_package-detail' style={fromGradPackages ? { minHeight: '276px' } : {}}>
												<div className='grad_package-best-label'>
													{((fromGradPackages && product?.mostPopular) || index === 0) && <div>{CARD_LABELS.MOST_POPULAR}</div>}
													{product?.freeShipping && <div>{CARD_LABELS.FREE_SHIPPING}</div>}
												</div>

												<div className='grad_package-name'>
													<span title={product.displayName + "."}>{product.displayName?.replace("Package", "")}</span>
													<div
														className='long-desc-popup d-none'
														id={'product-name-popup-' + index}>
														<button
															className='close' title="Close"
															onClick={() => {
																document
																	.getElementById('product-name-popup-' + index)
																	.classList.add('d-none');
															}}>
															<i className='fas fa-times'></i>
														</button>
														<div className='long-desc-popup-text'>{product.displayName}</div>
													</div>
													{
														product.displayName.length && product.displayName.length >= 20 &&
														<span
															className='show-long-desc-popup d-sm-none'
															onClick={() => {
																document
																	.getElementById('product-name-popup-' + index)
																	.classList.remove('d-none');
															}}>
															<i className='fas fa-info-circle'></i>
														</span>
													}
													<span>{"PACKAGE"}</span>
												</div>

												<div className='grad_package-price'>
													{price}
												</div>

												<div className='grad_package-btn'>
													<div
														className='btn btn-primary btn-sm'
														id='package_buy-btn'
														onClick={() => onCustomizeClick(product, "PackageGridUpper")}
														data-package-osr={product[fromGradPackages ? 'publishedCatalogProductId' : 'productOsr']}
														data-category-osr=''>
														{CARD_LABELS.CUSTOMIZE}
													</div>
												</div>
												{fromGradPackages && savePrice && (
													<div style={{ marginTop: '10px' }} className='price-row'>
														{CARD_LABELS.SAVE(savePrice)}
													</div>
												)}

												<div className='grad_package-info'>
													<ul className='grad_package-list'>
														<li className={`grad_package-item ${product.repMessage ? '' : 'no-top-border'}`}>
															{product.repMessage && getDisplayValue(product.repMessage, "i" + index)}
														</li>
													</ul>
												</div>
											</div>
											<div className='grad_package-info'>
												<ul className='grad_package-list'>
													{uniquePackagesList?.length > 0 && uniquePackagesList.map(
														(item, key) => (
															<li className='grad_package-item' key={key}>
																{item.packageProductAvailability.map(
																	(packageItem, indexValue) =>
																		packageItem.packageOsr ===
																			product[fromGradPackages ? 'publishedCatalogProductId' : 'productOsr']
																			? getDisplayValue(
																				packageItem.display,
																				indexValue
																			)
																			: null
																)}
															</li>
														)
													)}
												</ul>
											</div>
											<div className='grad_package-btn top-border'>
												<div
													className='btn btn-primary btn-sm'
													id='package_buy-btn'
													onClick={() => {
														onCustomizeClick(product, "PackageGridLower");
													}}
													data-package-osr={product[fromGradPackages ? 'publishedCatalogProductId' : 'productOsr']}
													data-category-osr=''>
													{CARD_LABELS.CUSTOMIZE}
												</div>
											</div>
										</div>
									</div>
								);
							})}
					</div>
				</div>
			</section>
			{showCustomize && <LinkedProducts 
				linkedProducts={selectedProduct?.linkedProducts} showCustomize={showCustomize} 
				setShowCustomize={setShowCustomize} product={selectedProduct} altImage={altImage}
				googleAnalytics={googleAnalytics}
			/>}
		</>
	);
};

export default GradPackageTable